<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Pump Unit</mat-panel-title>
    <mat-panel-description>Pump unit fields</mat-panel-description>
  </mat-expansion-panel-header>

  <form [formGroup]="pumpUnitForm">
    <mat-form-field class="form-element">
      <mat-label>pu_item</mat-label>
      <input matInput placeholder="pu_item" formControlName="item" (input)="onInput($event.target.value, 'item')">
    </mat-form-field>

    <app-packaging-store></app-packaging-store>

    <mat-form-field class="form-element">
      <mat-label>pu_max_temp</mat-label>
      <input matInput placeholder="pu_max_temp" formControlName="maxTemp" (input)="onInput($event.target.value, 'maxTemp')">
    </mat-form-field>

    <mat-form-field class="form-element">
      <mat-label>pu_suction_head</mat-label>
      <input matInput placeholder="pu_suction_head" formControlName="suctionHead"
        (input)="onInput($event.target.value, 'suctionHead')">
    </mat-form-field>

    <app-drawing-view class="form-wrapper__view-wrapper" data-testid="drawing"
      formControlName="drawing"
      (urlChange)="onDrawingSelect($event)">
    </app-drawing-view>

    <app-picture-select-new class="form-wrapper__picture-wrapper"
      formControlName="picture"
      (urlChange)="onPictureSelect($event)">
    </app-picture-select-new>
  </form>
</mat-expansion-panel>